<template>
  <header class="app-header">
    <a class="app-header__logo" href="#">IT SERVICES</a>
    <!-- Sidebar toggle button-->
    <a
      class="app-sidebar__toggle"
      href="#"
      @click.prevent="toggleSidebar"
      aria-label="Hide Sidebar"
    >
      <i class="fas fa-bars"></i>
    </a>
    <!-- Navbar Right Menu-->
    <ul class="app-nav">
      <li class="dropdown">
        <a
          v-if="status_report.length"
          data-toggle="dropdown"
          href="#"
          aria-expanded="true"
          class="app-nav__item"
          ><i class="far fa-bell fa-lg"></i
          ><span
            v-if="status_report.length"
            class="badge badge-danger navbar-badge"
          >
            !
          </span></a
        >
        <ul class="app-notification dropdown-menu dropdown-menu-right">
          <li class="app-notification__title">
            คุณมีการแจ้งเตือนใหม่ {{ status_report.length }} รายการ
          </li>
          <div class="app-notification__content">
            <li v-for="(item, index) in status_report" :key="index">
              <router-link
                :to="{ name: 'RepairStatus', params: { id: item.status_id } }"
                class="app-notification__item"
              >
                <span class="app-notification__icon"
                  ><span class="fa-stack fa-lg"
                    ><i
                      class="fa fa-circle fa-stack-2x"
                      :class="{
                        'text-info': item.status_id == 4,
                        'text-danger': item.status_id == 2,
                        'text-secondary': item.status_id == 1,
                      }"
                    ></i>
                    <i
                      v-show="item.status_id == 3"
                      class="fas fa-check-circle fa-stack-1x fa-inverse"
                      title="รอ"
                    ></i>
                    <i
                      v-show="item.status_id == 1"
                      class="fas fa-hourglass-half fa-stack-1x fa-inverse"
                      title="รอ"
                    ></i>
                    <i
                      v-show="item.status_id == 4"
                      class="fas fa-hammer fa-stack-1x fa-inverse"
                      title="กำลัง"
                    ></i>
                    <i
                      v-show="item.status_id == 2"
                      class="far fa-times-circle fa-stack-1x fa-inverse"
                      title="ยกเลิก"
                    ></i>
                  </span>
                </span>
                <div>
                  <p class="app-notification__message" v-if="item.status">
                    {{ item.status.status_name }}
                  </p>
                  <p class="app-notification__meta">
                    {{ item.status_count }} รายการ
                  </p>
                </div>
              </router-link>
            </li>
          </div>
          <li class="app-notification__footer">
            <router-link to="/Repairs"> ดูการแจ้งเตือนทั้งหมด. </router-link>
          </li>
        </ul>
      </li>
      <!-- User Menu-->
      <li class="dropdown">
        <a
          class="app-nav__item"
          href="#"
          data-toggle="dropdown"
          aria-label="Open Profile Menu"
        >
          <i class="fa fa-user fa-lg mr-3"></i>
          <span class="user-name-text">{{ user.name }}</span>
        </a>
        <ul class="dropdown-menu settings-menu dropdown-menu-right">
          <!-- <li>
            <a class="dropdown-item" href="#" disabled
              ><i class="fa fa-cog fa-lg"></i> การตั้งค่า</a
            >
          </li> -->
          <!-- <li>
            <router-link to="Profile" class="dropdown-item">
              <i class="fa fa-user fa-lg"></i> ข้อมูลส่วนตัว
            </router-link>
          </li> -->
          <li>
            <a @click="logout" class="dropdown-item" href="#"
              ><i class="fas fa-sign-out-alt fa-lg"></i> ออกจากระบบ</a
            >
          </li>
        </ul>
      </li>
    </ul>
  </header>
</template>

<script>
// const EventBus = this.$root;
import { EventBus } from "@/event-bus";

export default {
  data() {
    return {
      status_report: [],
      activeDropdown: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.Auth.user || {};
    },
  },
  methods: {
    toggleSidebar() {
      const app = document.querySelector(".app");
      if (app) {
        app.classList.toggle("sidenav-toggled");
      }
    },
    logout() {
      if (confirm("คุณต้องการออกจากระบบใช่หรือไม่?")) {
        this.$store.dispatch("logout");
      }
    },
    dropdown() {
      this.$refs.dropdown.classList.add("show");
    },
    async getStatus() {
      try {
        const res = await this.$http.get("/status_report");
        this.status_report = res.data || [];
      } catch (err) {
        console.error("Notification Error:", err);
      }
    },
  },
  mounted() {
    EventBus.$on("my-event-name", (param1, param2) => {
      this.getStatus();
    });
  },
  created() {
    this.getStatus();
  },
};
</script>

<style>
.blink_me {
  animation: blinker 1.8s linear infinite;
}

@media (max-width: 767px) {
  .user-name-text {
    display: none; /* ซ่อนชื่อบนมือถือเพื่อลดความแออัด */
  }

  .notification-dropdown {
    width: 280px !important;
    position: absolute;
    right: -50px !important; /* จัดตำแหน่งให้ตรงกลางจอมากขึ้น */
  }

  .app-header__logo {
    font-size: 1rem;
  }
}

@keyframes blinker {
  25% {
    opacity: 0;
  }
}
</style>